<div class="app-login">
  <div class="content">
    <div class="login-wait">
      {{ 'Access.ProcessingLogin' | translate}}
    </div>
  </div>
</div>
